import { render, staticRenderFns } from "./WorldDestinations.vue?vue&type=template&id=b32ec7a6&"
import script from "./WorldDestinations.vue?vue&type=script&lang=js&"
export * from "./WorldDestinations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports